module.exports = __webpack_public_path__ + "static/img/pic.3aba087c.png";